// extracted by mini-css-extract-plugin
export var addressFields = "_nj-0";
export var animationContainer = "_nj-1";
export var footer = "_nj-2";
export var lineItems = "_nj-3";
export var modalContent = "_nj-4";
export var orderName = "_nj-5";
export var strong = "_nj-6";
export var warning = "_nj-7";